import ProjectVariation from "../types/ProjectVariation";
import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getProjectVariation = (
    token: string,
    backend: string,
    id: number
) => {
    return fetch(
        `${getApiUrl(backend)}project_variations/${id}`,
        {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
                Accept: 'application/json, text/plain, */*'
            }
        }
    );
};

export default getProjectVariation;
